export enum Label {
  BackupBattery = '予備電池',
  NormalBattery = '通常電源',
  DoorOpen = '扉OPEN',
  DoorClose = '扉CLOSE',
  KeyOpen = '鍵OPEN',
  KeyClose = '鍵CLOSE',
}
